import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    backgroundColor: primary.gray3,
    borderRadius: 4,
    color: primary.bluish1,
    display: 'flex',
    alignItems: 'center',
    padding: spacing(1, 2),
    width: 'fit-content',
  },
  label: {
    fontSize: 10,
    lineHeight: '12px',
    textTransform: 'uppercase',
    userSelect: 'none',
  },
}));

const ProposedStatus = ({ proposedLabel }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.label} variant="overline">
        {proposedLabel}
      </Typography>
    </div>
  );
};

ProposedStatus.propTypes = {
  proposedLabel: PropTypes.string.isRequired,
};

export default ProposedStatus;
